<template>
  <div class="personIndex">
     <Header title="报到注册" type='0' route="/homeIndex"></Header>
     <NOdata v-if="this.Mine.length == 0" title="暂无数据~"></NOdata>
    <div class="per-bg">
      <div class="info-detail">
        <div class="info-item">
          <p class="item-name item-first">报到学期：</p>
          <span class="item-first" v-if="this.Mine.xqmc">{{this.Mine.xqmc}}</span>
        </div>
        <div class="info-item">
          <p class="item-name">报到起始时间：</p>
          <span v-if="this.Mine.starttime2">{{this.Mine.starttime2}}</span>
        </div>
        <div class="info-item">
          <p class="item-name">报到结束时间：</p>
          <span v-if="this.Mine.endtime2">{{this.Mine.endtime2}}</span>
        </div>
        <div>
          <div class="info-item" >
            <p class="item-name">报到状态：</p>
            <span v-if="this.Mine.bdzt">{{this.Mine.bdzt}}</span>
          </div>
         
        </div>
        <div v-if="schoolCode == '10560'">
          <div class="info-item" >
            <p class="item-name">注册状态：</p>
            <span v-if="this.Mine.zcztm == '1'">已注册</span>
            <span v-else>未注册</span>
          </div>
         
        </div>
      </div>
    </div>
    <div
      class="grey-contain"
      @click="exitLog()"
     v-if="this.Mine.bdzt!='已报到'&&this.Mine.iscnbd=='1' && schoolCode != '10560'"
    >
      <p>报到</p>
    </div>
    <div
      class="grey-contain"
      @click="exitLog()"
     v-if="this.Mine.bdzt!='已报到'&&this.Mine.iscnbd=='1' && schoolCode == '10560' && this.Mine.issfqyyddbdzc == '1'"
    >
      <p>报到</p>
    </div>
    <div
      class="grey-contain"
      @click="exitLogzc(Mine.xnxq01id)"
     v-if="this.Mine.bdzt=='已报到'&&this.Mine.iscnzc=='1' && schoolCode == '10560' && this.Mine.zcztm!='1' && this.Mine.issfqyyddbdzc == '1'"
    >
      <p>注册</p>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Api } from "../../../utils/axios";
export default {
  inject: ['reload'],
  data() {
    return {
      schoolCode: sessionStorage.getItem("schoolCode"),
     // isWechat: sessionStorage.getItem("isWechat"),
      //thirdLogin: sessionStorage.getItem("thirdLogin"),
     // isNeedLogout: sessionStorage.getItem("isNeedLogout"),
     // Identity: sessionStorage.getItem("Identity"),
     // forgetPwd: sessionStorage.getItem("forgetPwd"),
     // release: sessionStorage.getItem("release"),
      Mine: [],
     // headPic: require("../../../../static/img/head.jpeg")
    };
  },
  created() {
    this.getReastData();//初始化数据
  },
  methods: {
    async getReastData() {
      //const res = await Api.getStuInfo();
      const res = await Api.getRegistData();
      this.Mine = res.data;
    },
    async toReasit(params) {
      const res = await Api.toRegistRationAction(params);
      if (res.code == 0 ) {
        this.$toast("报到失败！");
      } else if (res.code == 1) {
        this.$toast.success("报到成功!");
        //this.$router.go(0);
        this.reload();
        //alert(window.location.href);
        //location.href = window.location.href;
      }else if(res.code == 2){
        this.$toast(res.Msg);
      }
    },
    exitLog() {
       const params = {
          bdzt:'1'
        }
      Dialog.confirm({
        message: "确认报到？"
      }).then(() => {
         this.toReasit(params);
        })
        .catch(() => {
          // on cancel
        });
    },
    exitLogzc(xnxq01id) {
       const params = {
        xnxqid:xnxq01id
        }
      Dialog.confirm({
        message: "确认注册？"
      }).then(() => {
         this.saveXszc(params);
        })
        .catch(() => {
          // on cancel
        });
    },
    async saveXszc(params) {
      const res = await Api.tosaveXszc(params);
      if (res.code == 0 ) {
        this.$toast(res.Msg);
      } else {
        this.$toast(res.Msg);
        this.reload();
      }
    },
  },
  components: {
    [Dialog.Component.name]: Dialog.Component
  }
};
</script>

<style scoped lang="less">
.personIndex {
  .per-head {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 2px solid @attendance-background-color-12;
    position: absolute;
    top: 16px;
    right: 16px;
  }
  .per-bg {
    position: relative;
    margin: 8px 20px;
    background: url(../../../../static/img/per_bg.png) no-repeat center;
    min-height: 80px;
    background-size: 100% 100%;
    color: @attendance-color-3;
    padding: 0 16px 12px 20px;
  }
  .per-name {
    padding-top: 20px;
    font-weight: 600;
    margin-bottom: 10px;
    max-width: ~"calc(100% - 90px)";
  }
  .per-info {
    display: flex;
    align-items: center;
  }
  .per-info img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  .info-detail {
    margin-top: 20px;
  }
  .info-item {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
  }
  .item-name {
    color: @attendance-background-color-15;
  }
  .grey-contain p {
    font-weight: 600;  
  }
  .black-title {
    margin: -22px 20px 0;
  }

  .item-first {
    padding-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/student/RegistraTion/list.vue